import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=7528cbd2&scoped=true&"
import script from "./Avatar.vue?vue&type=script&setup=true&lang=js&"
export * from "./Avatar.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7528cbd2",
  null
  
)

export default component.exports